import { Link } from 'react-router-dom';
import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';
import CountdownTimer from '../../../components/feature/CountdownTimer';

export default function Services() {
  const services = [
    { icon: 'ri-car-line', title: 'Seguro Automóvel', description: 'Contratação profissional com análise técnica, negociação estratégica e economia garantida.', link: '/servicos/automovel' },
    { icon: 'ri-team-line', title: 'Vida Empresarial', description: 'Avaliação financeira completa para proteger sócios e garantir continuidade do negócio.', link: '/servicos/vida-empresarial' },
    { icon: 'ri-file-list-3-line', title: 'Gestão de Contratos', description: 'Gestão financeira estratégica de todos os seus contratos de seguro com otimização contínua.', link: '/servicos/gestao-contratos' },
    { icon: 'ri-shield-flash-line', title: 'Recuperação de Sinistros', description: 'Suporte técnico especializado para garantir indenizações justas e rápidas.', link: '/servicos/recuperacao-sinistros' },
    { icon: 'ri-lightbulb-line', title: 'Consultoria Técnica', description: 'Análise profunda de riscos e recomendações estratégicas personalizadas.', link: '/servicos/consultoria-tecnica' },
    { icon: 'ri-customer-service-2-line', title: 'Suporte Contínuo', description: 'Acompanhamento permanente com revisões periódicas e atendimento prioritário.', link: '/servicos/suporte-acompanhamento' }
  ];

  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, visibleItems } = useStaggerAnimation(services.length);
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation();

  return (
    <section id="servicos" className="py-16 sm:py-20 lg:py-28 bg-gradient-to-br from-petrol-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-12 sm:mb-16 transition-all duration-700 ease-out ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="inline-flex items-center gap-2 bg-petrol-100 px-4 py-2 rounded-full mb-4 sm:mb-6">
            <i className="ri-service-line text-petrol-600 text-base"></i>
            <span className="text-petrol-700 font-bold text-xs sm:text-sm uppercase tracking-wide">Nossos Serviços</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-petrol-900 mb-4 sm:mb-6 px-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Soluções Completas em{' '}
            <span className="text-strategic-green-500">Gestão de Riscos</span>
          </h2>
          <p className="text-base sm:text-lg text-petrol-700 max-w-3xl mx-auto leading-relaxed px-4">
            Da análise técnica à recuperação de sinistros, oferecemos gestão profissional completa para <strong className="text-petrol-900">proteger seu patrimônio</strong> e <strong className="text-petrol-900">reduzir custos</strong>.
          </p>
        </div>

        <div ref={gridRef as React.RefObject<HTMLDivElement>} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className={`bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl border border-petrol-100 hover:border-strategic-green-400 group cursor-pointer transition-all duration-700 ease-out ${visibleItems[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="w-14 h-14 bg-gradient-to-br from-strategic-green-500 to-strategic-green-600 rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-petrol-900 mb-3 sm:mb-4 group-hover:text-strategic-green-600 transition-colors leading-tight">
                {service.title}
              </h3>
              <p className="text-sm sm:text-base text-petrol-700 leading-relaxed mb-4 sm:mb-6">{service.description}</p>
              <div className="flex items-center gap-2 text-strategic-green-600 font-semibold text-sm group-hover:gap-3 transition-all">
                <span>Saiba mais</span>
                <i className="ri-arrow-right-line text-base"></i>
              </div>
            </Link>
          ))}
        </div>

        <div
          ref={ctaRef as React.RefObject<HTMLDivElement>}
          className={`bg-gradient-to-r from-petrol-900 to-petrol-700 rounded-xl sm:rounded-2xl p-6 sm:p-10 text-center shadow-2xl transition-all duration-700 ease-out ${ctaVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'}`}
        >
          <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 px-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            Precisa de Um Serviço Específico?
          </h3>
          <p className="text-sm sm:text-base text-gray-200 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            Fale com nossos especialistas e descubra como podemos ajudar sua empresa ou família.
          </p>
          
          <CountdownTimer location="servicos" />
          
          <div className="text-center">
            <a
              href="/servicos"
              className="inline-flex items-center justify-center px-8 py-4 bg-action-orange-500 text-white text-lg font-semibold rounded-lg hover:bg-action-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Ver Todos os Serviços
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}